module.exports = __webpack_public_path__ + "static/uni_nc_atsu-cadd9bb30e009aaa54a509f074d7015c.png";